import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';

export interface IgnoreErrorData {
  reportId: number | string;
  fieldKey: string;
  label: string;
  message: string;
  /** The error as returned by verification. */
  error: any;
}

const MAX_FILE_BYTES = 10 * 1024 * 1024;

/**
 * Ignore one error of a report: asks for a reason and optional attachments and records them.
 * Closes with the saved record, or false when cancelled.
 */
@Component({
  selector: 'app-ignore-error-popup',
  templateUrl: './ignore-error-popup.component.html',
  styleUrls: ['./ignore-error-popup.component.scss'],
})
export class IgnoreErrorPopupComponent {
  reason = '';
  files: File[] = [];
  saving = false;
  errorText = '';

  constructor(
    public dialogRef: MatDialogRef<IgnoreErrorPopupComponent, any>,
    @Inject(MAT_DIALOG_DATA) public data: IgnoreErrorData,
    private formService: PortRequestFormServiceService,
  ) {}

  onFiles(event: Event): void {
    const input = event.target as HTMLInputElement;
    for (const file of Array.from(input.files || [])) {
      if (file.size > MAX_FILE_BYTES) {
        this.errorText = `${file.name} is larger than 10 MB.`;
        continue;
      }
      this.files.push(file);
    }
    input.value = '';
  }

  removeFile(index: number): void {
    this.files.splice(index, 1);
  }

  fileSize(bytes: number): string {
    return bytes < 1024 * 1024 ? `${Math.max(1, Math.round(bytes / 1024))} KB` : `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  }

  save(): void {
    if (!this.reason.trim() || this.saving) return;
    this.saving = true;
    this.errorText = '';
    const form = new FormData();
    form.append('report_id', String(this.data.reportId));
    form.append('field_key', this.data.fieldKey);
    form.append('reason', this.reason.trim());
    form.append('error', JSON.stringify(this.data.error || { label: this.data.label, message: this.data.message }));
    form.append('user_name', localStorage.getItem('subUsername') || localStorage.getItem('username') || '');
    form.append('user_login', localStorage.getItem('loginPic') || localStorage.getItem('bungeUsername') || '');
    this.files.forEach((f) => form.append('files', f, f.name));
    this.formService.ignoreReportError(form).subscribe({
      next: (res: any) => {
        this.saving = false;
        if (res?.success) {
          this.dialogRef.close(res);
        } else {
          this.errorText = res?.error || 'Could not ignore this error.';
        }
      },
      error: (err) => {
        this.saving = false;
        this.errorText = err?.error?.error || 'Could not ignore this error.';
      },
    });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
